(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.score = 0;
        this.status = Game.STATUS.idle;
        this.initialState = initialState;
        this.state = initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                if (this.getStatus() !== Game.STATUS.playing) return;
                var moveAbility = false;
                var newState = this.state.map(function(row) {
                    var filterRow = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    var newRow = [];
                    for(var i = 0; i < filterRow.length; i++)if (filterRow[i] === filterRow[i + 1]) {
                        var mergedValue = filterRow[i] * 2;
                        newRow.push(mergedValue);
                        _this.score += mergedValue;
                        i++;
                        moveAbility = true;
                    } else newRow.push(filterRow[i]);
                    while(newRow.length < row.length)newRow.push(0);
                    if (!moveAbility) moveAbility = !row.every(function(cell, index) {
                        return cell === newRow[index];
                    });
                    return newRow;
                });
                if (moveAbility) {
                    this.state = newState;
                    this.addNumbers();
                    this.setState();
                    this.checkStatus();
                }
                return moveAbility;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (this.getStatus() !== Game.STATUS.playing) return;
                var moveAbility = false;
                var newState = this.state.map(function(row) {
                    var filterRow = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    var newRow = [];
                    for(var i = filterRow.length - 1; i >= 0; i--)if (filterRow[i] === filterRow[i - 1]) {
                        var mergedValue = filterRow[i] * 2;
                        newRow.unshift(mergedValue);
                        _this.score += mergedValue;
                        i--;
                        moveAbility = true;
                    } else newRow.unshift(filterRow[i]);
                    while(newRow.length < row.length)newRow.unshift(0);
                    if (!moveAbility && !row.every(function(cell, index) {
                        return cell === newRow[index];
                    })) moveAbility = true;
                    return newRow;
                });
                if (moveAbility) {
                    this.state = newState;
                    this.addNumbers();
                    this.setState();
                    this.checkStatus();
                }
                return moveAbility;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.getStatus() !== Game.STATUS.playing) return;
                var moveAbility = false;
                var newState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                for(var c = 0; c < this.state[0].length; c++){
                    var filterColumn = [];
                    for(var r = 0; r < this.state.length; r++)if (this.state[r][c] !== 0) filterColumn.push(this.state[r][c]);
                    var newColumn = [];
                    for(var i = 0; i < filterColumn.length; i++)if (filterColumn[i] === filterColumn[i + 1]) {
                        var mergedValue = filterColumn[i] * 2;
                        newColumn.push(mergedValue);
                        this.score += mergedValue;
                        i++;
                        moveAbility = true;
                    } else newColumn.push(filterColumn[i]);
                    while(newColumn.length < this.state.length)newColumn.push(0);
                    for(var r1 = 0; r1 < this.state.length; r1++)if (newState[r1][c] !== newColumn[r1]) {
                        newState[r1][c] = newColumn[r1];
                        moveAbility = true;
                    }
                }
                if (moveAbility) {
                    this.state = newState;
                    this.addNumbers();
                    this.setState();
                    this.checkStatus();
                }
                return moveAbility;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.getStatus() !== Game.STATUS.playing) return;
                var moveAbility = false;
                var newState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                for(var c = 0; c < this.state[0].length; c++){
                    var filterColumn = [];
                    for(var r = this.state.length - 1; r >= 0; r--)if (this.state[r][c] !== 0) filterColumn.push(this.state[r][c]);
                    var newColumn = [];
                    for(var i = 0; i < filterColumn.length; i++)if (filterColumn[i] === filterColumn[i + 1]) {
                        var mergedValue = filterColumn[i] * 2;
                        newColumn.unshift(mergedValue);
                        this.score += mergedValue;
                        i++;
                        moveAbility = true;
                    } else newColumn.unshift(filterColumn[i]);
                    while(newColumn.length < this.state.length)newColumn.unshift(0);
                    for(var r1 = 0; r1 < this.state.length; r1++)if (newState[r1][c] !== newColumn[r1]) {
                        newState[r1][c] = newColumn[r1];
                        moveAbility = true;
                    }
                }
                if (moveAbility) {
                    this.state = newState;
                    this.addNumbers();
                    this.setState();
                    this.checkStatus();
                }
                return moveAbility;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = Game.STATUS.playing;
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.addNumbers();
                this.addNumbers();
                this.setState();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = Game.STATUS.idle;
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.setState();
            }
        },
        {
            key: "getRandomNumber",
            value: function getRandomNumber() {
                return Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "addNumbers",
            value: function addNumbers() {
                var emptyCell = [];
                for(var rows = 0; rows < this.state.length; rows++){
                    for(var cells = 0; cells < this.state[rows].length; cells++)if (this.state[rows][cells] === 0) emptyCell.push({
                        r: rows,
                        c: cells
                    });
                }
                var randomIndex = Math.floor(Math.random() * emptyCell.length);
                var _emptyCell_randomIndex = emptyCell[randomIndex], r = _emptyCell_randomIndex.r, c = _emptyCell_randomIndex.c;
                var newState = this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                newState[r][c] = this.getRandomNumber();
                this.state = newState;
            }
        },
        {
            key: "setState",
            value: function setState() {
                var cells = document.querySelectorAll(".field-cell");
                var cellsValue = this.state.flat();
                if (cells.length === 0) return;
                for(var i = 0; i < cellsValue.length; i++){
                    var currentCells = cells[i];
                    var currentValue = cellsValue[i];
                    if (!currentCells) continue;
                    currentCells.className = "field-cell";
                    if (currentValue > 0) {
                        currentCells.textContent = currentValue;
                        currentCells.classList.add("field-cell--".concat(currentValue));
                    } else currentCells.textContent = "";
                }
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                var moveAbility = false;
                var mergeAbility = false;
                for(var i = 0; i < this.state.length; i++){
                    for(var j = 0; j < this.state[i].length; j++)if (this.state[i][j] === 2048) {
                        this.status = Game.STATUS.win;
                        return;
                    }
                }
                for(var i1 = 0; i1 < this.state.length; i1++){
                    for(var j1 = 0; j1 < this.state[i1].length - 1; j1++)if (this.state[i1][j1] === this.state[i1][j1 + 1]) {
                        mergeAbility = true;
                        break;
                    }
                    if (mergeAbility) break;
                }
                if (!mergeAbility) for(var i2 = 0; i2 < this.state.length - 1; i2++){
                    for(var j2 = 0; j2 < this.state[i2].length; j2++)if (this.state[i2][j2] === this.state[i2 + 1][j2]) {
                        mergeAbility = true;
                        break;
                    }
                    if (mergeAbility) break;
                }
                for(var i3 = 0; i3 < this.state.length; i3++){
                    for(var j3 = 0; j3 < this.state[i3].length; j3++)if (this.state[i3][j3] === 0) {
                        moveAbility = true;
                        break;
                    }
                    if (moveAbility) break;
                }
                if (!moveAbility && !mergeAbility) this.status = Game.STATUS.lose;
            }
        }
    ]);
    return Game;
}();
(0, $cd5a47cf8ef6d766$export$71511d61b312f219)($3d28d7f1aac198f5$var$Game, "STATUS", {
    idle: "idle",
    playing: "playing",
    win: "win",
    lose: "lose"
});
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$MOVE_LEFT = "ArrowLeft";
var $197cd56b15c33885$var$MOVE_RIGHT = "ArrowRight";
var $197cd56b15c33885$var$MOVE_UP = "ArrowUp";
var $197cd56b15c33885$var$MOVE_DOWN = "ArrowDown";
var $197cd56b15c33885$var$buttonStart = document.querySelector(".button");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$score = document.querySelector(".game-score");
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$score.textContent = $197cd56b15c33885$var$game.score;
}
$197cd56b15c33885$var$buttonStart.addEventListener("click", $197cd56b15c33885$var$startGame);
function $197cd56b15c33885$var$startGame() {
    $197cd56b15c33885$var$buttonStart.classList.toggle("restart");
    $197cd56b15c33885$var$buttonStart.classList.toggle("start");
    $197cd56b15c33885$var$messageStart.classList.toggle("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$score.textContent = 0;
    if ($197cd56b15c33885$var$buttonStart.className.includes("start")) {
        $197cd56b15c33885$var$buttonStart.textContent = "Start";
        $197cd56b15c33885$var$game.restart();
    }
    if ($197cd56b15c33885$var$buttonStart.className.includes("restart")) {
        $197cd56b15c33885$var$buttonStart.textContent = "Restart";
        $197cd56b15c33885$var$game.start();
    }
    document.addEventListener("keydown", $197cd56b15c33885$var$arrowMove);
}
var $197cd56b15c33885$var$deleteMove = function() {
    return document.removeEventListener("keydown", $197cd56b15c33885$var$arrowMove);
};
function $197cd56b15c33885$var$arrowMove(action) {
    if ($197cd56b15c33885$var$game.getStatus() === $3d28d7f1aac198f5$exports.STATUS.playing) {
        var canMove = false;
        switch(action.key){
            case $197cd56b15c33885$var$MOVE_LEFT:
                canMove = $197cd56b15c33885$var$game.moveLeft();
                break;
            case $197cd56b15c33885$var$MOVE_RIGHT:
                canMove = $197cd56b15c33885$var$game.moveRight();
                break;
            case $197cd56b15c33885$var$MOVE_UP:
                canMove = $197cd56b15c33885$var$game.moveUp();
                break;
            case $197cd56b15c33885$var$MOVE_DOWN:
                canMove = $197cd56b15c33885$var$game.moveDown();
                break;
            default:
                break;
        }
        if (canMove) $197cd56b15c33885$var$updateScore();
    }
    if ($197cd56b15c33885$var$game.getStatus() === $3d28d7f1aac198f5$exports.STATUS.lose) {
        $197cd56b15c33885$var$messageLose.classList.remove("hidden");
        $197cd56b15c33885$var$deleteMove();
    }
    if ($197cd56b15c33885$var$game.getStatus() === $3d28d7f1aac198f5$exports.STATUS.win) {
        $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        $197cd56b15c33885$var$deleteMove();
    }
    action.preventDefault();
}
document.addEventListener("keydown", $197cd56b15c33885$var$arrowMove);

})();
//# sourceMappingURL=index.074bee5e.js.map
